import React from 'react';
import { Navigate } from 'react-router-dom';
import PersonnelDocuments from '@/components/PersonnelDocuments';
import { useEffectiveMe } from '@/lib/effectiveMe';
import { hasCap, isPureEmployee } from '@/lib/capabilities';

export default function DocumentiPersonale() {
  const me = useEffectiveMe();
  if (isPureEmployee(me)) return <Navigate to="/access-denied" replace />;
  const legacyManage = hasCap(me, 'personale.documents.manage');
  const hasDocumentCapability = (code) => hasCap(me, code) || hasCap(me, 'personale.documents.*');
  return <PersonnelDocuments mode="admin" onManagePermission={legacyManage} capabilities={{
    canRead: hasDocumentCapability('personale.documents.read') || hasCap(me, 'employee.view') || hasCap(me, 'personale.view') || legacyManage,
    canCompanyUpload: hasDocumentCapability('personale.documents.company.upload') || legacyManage,
    canReplace: hasDocumentCapability('personale.documents.replace') || legacyManage,
    canDelete: hasDocumentCapability('personale.documents.delete') || legacyManage,
    canSensitive: hasCap(me, 'personale.documents.sensitive.read'),
    canManagePolicy: hasDocumentCapability('personale.documents.policy.manage'),
  }} />;
}
